import { render, staticRenderFns } from "./ConstrainTable.vue?vue&type=template&id=4ae1f996"
import script from "./ConstrainTable.vue?vue&type=script&lang=ts"
export * from "./ConstrainTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports